export default __webpack_public_path__ + "static/media/ai_face_tracking.ce59417e.svg";